// LOCAL FEModule: the Credits/Info page (`/about`), linked from the button at the
// bottom of the rail. It REPLACES the kit's `module-about`, which draws the "KORU
// Nova" lockup — wordmark and gradient wired inside `<KoruLogo>` — with no slot to
// override it. Same name, same route, same footer entry: the swap is invisible to
// everything that reads the mounted module, the page and the colophon aside.

import type { FEModule } from "@spinning-top/koru-nova-frontend-module-contract";
import { AboutPage } from "./views/about-page.tsx";
import { i18n } from "./i18n/index.ts";

export const aboutModule: FEModule = {
  name: "about",
  routes: [
    {
      path: "/about",
      layout: "authenticated",
      component: AboutPage,
      // `/about` is a railFooterEntry and not a menuEntry → the breadcrumb would not
      // find it among the groups and would fall back on the brand. `breadcrumbKey`
      // gives it the label of its own button.
      breadcrumbKey: "about:menu.about",
    },
  ],
  menuEntries: [],
  // Info button anchored at the bottom of the rail: a direct link (no flyout),
  // visible to every authenticated user (no permission).
  railFooterEntries: [{ to: "/about", labelKey: "about:menu.about", icon: "info" }],
  i18n,
  declaredPermissions: [],
};

export default aboutModule;
